<template>
<div class="essay">
  <div class="wx_down" v-if="isWeixin">
    <div class="fl close" @click="closeDig"><img src="../assets/images/close_btn.png" alt=""></div>
    <div class="fl logo"><img src="../assets/images/logo.png" alt=""></div>
    <div class="fl headtxt">
      <div class="txt1">花生日记APP</div>
      <div class="txt2">花钱有方 生财有道</div>
    </div>
    <div class="fr download" >
      <router-link tag="div" to="./download">立即下载</router-link>
    </div>
  </div>



  <div class="img"><img :src="content.banner" alt=""></div>
  <div class="container">
<!--     <div class="des">
      <div class="fl">花生精选</div>
    </div> -->
    <!-- <div class="tt">{{h5title}}</div> -->
    <!-- <div class="date">{{content.publishDate |timeString}}</div> -->
    <div class="content" v-html="content.pageContent"></div>
  </div>
</div>
</template>

<script>
import utils from '../assets/js/utils'
export default {
  name: 'essay',
  data () {
    return{
      content:{
      },

        h5title:"详情",
      isWeixin: utils.isWeixin(),
      id:utils.getUrlStr('id')
    }
  },
  filters: {
    timeString(timeStamp) {
      if (timeStamp) {
        var date = new Date(timeStamp)
        var newDate = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
        return newDate
      }
    }
  },
  mounted() {
    
    const formData = new FormData()
    formData.append('h5Type',5)
    formData.append('id', utils.getUrlStr('id'))
     this.$http({
        method: 'post',
        url: '/api/peanut/findPeanutPage',
        data: formData
     }).then((res)=>{
      if(res.data.status === 200){
        if(res.data.type==2){
          window.location.href = res.data.data.pageUrl
        }else{
          this.content = res.data.data

        }

      }else{

        alert(res.data.msg)
        }
      })

          document.title = this.h5title
     console.log(this.list)
  },
  methods:{
    answer(item) {
    },
    closeDig(){
      this.isWeixin = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.essay{
   background: #fff; overflow: hidden;
  .container{padding: 0 0.75rem 1rem; background: #fff;}
  .img{
    img{display: block;}
  }
  .des{
    overflow: hidden; height:1.0rem; margin:0.5rem 0;
    .fl{color: #f42f19; font-size: 0.55rem; background: #fde0dd; width: 3.25rem; height: 1.0rem; border-radius: 0.5rem; line-height: 1rem; text-align: center; }
    .fr{color: #ccc; font-size: 0.6rem; }
    .icon{ padding-left: 1.375rem;  background-position: left center; background-repeat: no-repeat;height: 0.75rem; display: inline-block;margin-left: 0.75rem;}
    .eyes{background-image:url("../assets/images/eyes_icon.jpg");background-size:0.825rem 0.525rem;}
    .share{background-image:url("../assets/images/share_icon.jpg");background-size:0.65rem 0.75rem;}
  }
  .tt{color: #333333; font-size:0.85rem; margin:0.5rem 0 0.25rem;}
  .date{font-size: 0.65rem; color: #999; margin-bottom: 0.5rem;  position: relative;
    &:after{content: '';display: block; width: 1.75rem; height: 0.1rem; background: #f42f19; position: absolute; bottom: -0.25rem; left: 0;}
  }
  .content{margin-top: 1rem; font-size: 0.75rem;line-height: 1.4rem;}
  img{max-width: 100%;}
 
}
 .wx_down{
    position: fixed; top: 0; left: 0; width: 100%; height: 2.5rem; background-color: rgba(255,255,255,.6);
    .close{width: 1.05rem; height: 1.05rem; margin: 0.75rem 0.55rem;}
    .logo{width: 2.05rem; height: 2.05rem; margin-top: 0.25rem;}
    .headtxt{margin:0.3rem 0.375rem 0;}
    .txt1{color: #333; font-size: 0.7rem;}
    .txt2{color: #999; font-size: 0.55rem;}
    .download{background-color: #f42f19;  width: 4.75rem; height: 1.25rem; line-height: 1.25rem; text-align: center; color: #fff; margin: 0.5rem; font-size: 0.7rem;}
  }
</style>



// WEBPACK FOOTER //
// src/components/peanut.vue